module.exports = __webpack_public_path__ + "static/img/CStu4@2x.0e7668cb.png";